import React from 'react';
import Terminal from '../../components/Terminal';

// The old site, alive and well — now one app among many
const TerminalApp = () => <Terminal />;

export default TerminalApp;
